export const inputName = (name, prefix, index) => (typeof index === 'undefined'
    ? `${prefix || ''}${name}`
    : `${prefix || ''}${name}[${index}]`);
